import { useState } from 'react';
import { JFormik, sortString } from '@centerpiece/components';
import * as Yup from 'yup';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  useGetTagsQuery,
  useDeleteTagMutation,
  useUpdateTagMutation,
  useCreateTagMutation,
} from 'store/api';

export const TagsTab = () => {
  const [editing /*, setEditing*/] = useState<boolean>(false);
  const { data: tags = [], isLoading } = useGetTagsQuery({});
  const [createTag] = useCreateTagMutation();
  const [editTag] = useUpdateTagMutation();
  const [deleteTag] = useDeleteTagMutation();
  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <JFormik
      initialValues={() => ({
        tags: [...(tags || [])].sort((a, b) => sortString(a.name, b.name)),
      })}
      handleSubmit={async (values, formik) => {}}
      loading={isLoading}
      validationSchema={
        editing
          ? Yup.object({
              name: Yup.string().required('Project name is required'),
              // tag: Yup.object().nullable().required('Project tag is required'),
            })
          : Yup.object({})
      }
      disabled={!editing}
      form={[
        {
          name: 'tags',
          itemType: 'table_array',
          label: 'Tags',
          jItemProps: {
            addLabel: 'Add Tag',
          },
          tableProps: {
            onCreate: (values: any) => createTag(values),
            onEdit: (values: any) => editTag(values),
            onDelete: (id: number) => deleteTag(id),
            readOnly: (values: any) =>
              values?.subscription === undefined && values?.id > 0,
            // headers: [
            //   {
            //     name: 'name',
            //     label: 'Tag *',
            //     itemType: 'textfield',
            //     jItemProps: {
            //       width: '100%',
            //       sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
            //     },
            //     gridProps: { xs: 12 },
            //   },
            // ],
            columns: [
              {
                name: 'name',
                label: 'Tag *',
                itemType: 'textfield',
                jItemProps: {
                  width: '100%',
                  sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
                },
                gridProps: { xs: 12 },
              },
            ],
          },
          device: downSm ? 'mobile' : 'desktop',
        },
      ]}
    />
  );
};
